export default "__VITE_ASSET__B55OayVL__"